import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { useFilterCategories } from 'api';
import { filterCategoryState, filterConsultationTypeState } from 'store';
import { ConsultationFilterMultiSelect } from 'components';

export const ConsultationCategoryFilter: React.FC = () => {
  const { t } = useTranslation('filter');

  const { data: categoryData } = useFilterCategories();

  const selectedFilterTypes = useRecoilValue(filterConsultationTypeState);
  const isRpcOnly =
    selectedFilterTypes?.length === 1 && selectedFilterTypes[0].label === 'RPC';

  return (
    <>
      {!isRpcOnly && (
        <ConsultationFilterMultiSelect
          label={t('category_title', 'Category')}
          items={categoryData?.categories}
          state={filterCategoryState}
        />
      )}
    </>
  );
};
